module.exports = __webpack_public_path__ + "img/step-completed.2ec2108c.svg";